import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const momentFormat = 'YYYY-MM-DD';
const today = moment();

const state = {
    rows: [],
    statelessRowData: [],
    docTypes: [],
    endDate: today.format(momentFormat),
    startDate: today.subtract(1, 'months').format(momentFormat),
    needToSearch: true,
    selectAllChecked: false,
    showBalanceColumn: false,
    clientSampleTypes: [],
    selectedSampleTypes: [],
    showInProgress: true,
    userAccountRoles: {},
    userIsSysAdmin: false,
    activeFilters: {},
    activeSort: {},
    reportFormats: {}
};

let documentsModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default documentsModule;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/documents/index.js